import apiClient from "./axios";
import { ApiResponse, PaginatedResponse, PayIQUser } from "../types";

export interface GetUsersParams {
  search?: string;
  tier?: string;
  status?: string;
  isPremium?: boolean;
  page?: number;
  limit?: number;
}

export const usersApi = {
  getUsers: async (params: GetUsersParams = {}) => {
    const { data } = await apiClient.get<
      ApiResponse<PaginatedResponse<PayIQUser>>
    >("/admin/users", { params });
    return data.data;
  },

  getUserById: async (id: string) => {
    const { data } = await apiClient.get<ApiResponse<PayIQUser>>(
      `/admin/users/${id}`,
    );
    return data.data;
  },

  updateTier: async (id: string, tier: string, reason?: string) => {
    const { data } = await apiClient.patch<ApiResponse<PayIQUser>>(
      `/admin/users/${id}/tier`,
      { tier, reason },
    );
    return data.data;
  },

  updateStatus: async (id: string, status: string, reason?: string) => {
    const { data } = await apiClient.patch<ApiResponse<PayIQUser>>(
      `/admin/users/${id}/status`,
      { status, reason },
    );
    return data.data;
  },

  togglePremium: async (id: string, isPremium: boolean) => {
    const { data } = await apiClient.patch<ApiResponse<PayIQUser>>(
      `/admin/users/${id}/premium`,
      { isPremium },
    );
    return data.data;
  },

  resetLoginAttempts: async (id: string) => {
    const { data } = await apiClient.patch<ApiResponse<{ message: string }>>(
      `/admin/users/${id}/reset-login`,
    );
    return data.data;
  },

  revealSensitiveIdentifier: async (
    id: string,
    type: 'bvn' | 'nin',
    currentPassword: string,
  ) => {
    const { data } = await apiClient.post<ApiResponse<{ value: string }>>(
      `/admin/users/${id}/identifiers/${type}/reveal`,
      { currentPassword },
      {
        headers: {
          'Cache-Control': 'no-store',
          Pragma: 'no-cache',
        },
      },
    );
    return data.data;
  },
};
